import { HttpErrorResponse } from '@angular/common/http';

export const errorTitleKey = 'errors.title';
export const unidentifiedErrorKey = 'errors.unidentified';
export const forbiddenErrorKey = 'errors.forbidden';
export const networkErrorKey = 'errors.network';

export interface ParsedApiError {
  title?: string;
  titleKey?: string;
  message?: string;
  messageKey?: string;
}

export function parseApiError(error: HttpErrorResponse): ParsedApiError {
  if (!error || !error.status) {
    return { titleKey: errorTitleKey, messageKey: networkErrorKey };
  }

  const body = error.error;

  if (typeof body === 'string') {
    return body ? { titleKey: errorTitleKey, message: body } : getFallback(error.status);
  }

  return (body && typeof body === 'object' && parseObjectBody(body)) || getFallback(error.status);
}

function parseObjectBody(body: any): ParsedApiError {
  if (body.title) {
    return { title: body.title, message: body.ErrorMessage || body.detail || body.title };
  }

  if (body['@odata.context'] && typeof body.value === 'string' && body.value) {
    return { titleKey: errorTitleKey, message: body.value };
  }

  if (typeof body.error?.message === 'string' && body.error.message) {
    return { titleKey: errorTitleKey, message: body.error.message };
  }

  const modelStateMessage = getModelStateMessage(body.errors);

  if (modelStateMessage) {
    return { titleKey: errorTitleKey, message: modelStateMessage };
  }

  if (typeof body.message === 'string' && body.message) {
    return { titleKey: errorTitleKey, message: body.message };
  }

  return null;
}

function getModelStateMessage(errors: unknown): string {
  if (!errors || typeof errors !== 'object') {
    return '';
  }

  return Object.values(errors)
    .flat()
    .filter((item) => typeof item === 'string' && !!item.trim())
    .join('\n');
}

function getFallback(status: number): ParsedApiError {
  return { titleKey: errorTitleKey, messageKey: status === 403 ? forbiddenErrorKey : unidentifiedErrorKey };
}
